import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase"; // Adjust based on project structure
import { useNavigate } from "react-router-dom";
const FundAllocation = () => {
  const navigate = useNavigate();
   useEffect(() => {
      if(sessionStorage.getItem("login") !== "true"){
        navigate("/")
      }
    }, [])

  const [empid, setEmpid] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [budgetData, setBudgetData] = useState(null);
  const currentlogin = localStorage.getItem("empid")
  const [options, setOptions] = useState([]);
  console.log(localStorage.getItem("empid"))
  useEffect(() => {
    const addOptions = () => {
      
      if(currentlogin == "37" || currentlogin == "38" || currentlogin == "39" || currentlogin == "40" || currentlogin=="41" || currentlogin == "82" || currentlogin == "83" || currentlogin == "84" || currentlogin == "85" || currentlogin == "86")
      {
        document.getElementById("updatebtn").hidden = true
      }
      if (currentlogin == "31") {
        const newOptions = [
          { value: "1", label: "Kalimpong Horticulture" },
          { value: "2", label: "Kalimpong Soil Science" },
          { value: "3", label: "Kalimpong Plant Protection" },
          { value: "4", label: "Kalimpong Animal Science" },
          { value: "5", label: "Kalimpong Home Science" },
          { value: "6", label: "Kalimpong Extension" },
          { value: "7", label: "Coochbehar Horticulture" },
          { value: "8", label: "Coochbehar Soil Science" },
          { value: "9", label: "Coochbehar Plant Protection" },
          { value: "10", label: "Coochbehar Agronomy" },
          { value: "11", label: "Coochbehar Animal Science" },
          { value: "12", label: "Coochbehar Extension" },
          { value: "13", label: "Uttar Dinajpur Horticulture" },
          { value: "14", label: "Uttar Dinajpur Agronomy" },
          { value: "15", label: "Uttar Dinajpur Plant Protection" },
          { value: "16", label: "Uttar Dinajpur Animal Science" },
          { value: "17", label: "Uttar Dinajpur Home Science" },
          { value: "18", label: "Uttar Dinajpur Fishery Science" },
          { value: "19", label: "Dakshin Dinajpur Horticulture" },
          { value: "20", label: "Dakshin Dinajpur Soil Science" },
          { value: "21", label: "Dakshin Dinajpur Agronomy" },
          { value: "22", label: "Dakshin Dinajpur Animal Science" },
          { value: "23", label: "Dakshin Dinajpur Plant Protection" },
          { value: "24", label: "Dakshin Dinajpur Fishery Science" },
          { value: "25", label: "Malda Horticulture" },
          { value: "26", label: "Malda Agronomy" },
          { value: "27", label: "Malda Plant Protection" },
          { value: "28", label: "Malda Animal Science" },
          { value: "29", label: "Malda Extension" },
          { value: "30", label: "Malda Fishery Science" },
        ];
        setOptions(newOptions);
      }
      else if (currentlogin == "32" || currentlogin == "37" || currentlogin == "82") {
        const newOptions = [
          { value: "1", label: "Kalimpong Horticulture" },
          { value: "2", label: "Kalimpong Soil Science" },
          { value: "3", label: "Kalimpong Plant Protection" },
          { value: "4", label: "Kalimpong Animal Science" },
          { value: "5", label: "Kalimpong Home Science" },
          { value: "6", label: "Kalimpong Extension" },
          
        ]
        document.querySelectorAll(".myutil").forEach(input => input.disabled = true);
        setOptions(newOptions);
      }
      else if (currentlogin == "33" || currentlogin == "38"|| currentlogin == "83") {
        const newOptions = [
          { value: "7", label: "Coochbehar Horticulture" },
          { value: "8", label: "Coochbehar Soil Science" },
          { value: "9", label: "Coochbehar Plant Protection" },
          { value: "10", label: "Coochbehar Agronomy" },
          { value: "11", label: "Coochbehar Animal Science" },
          { value: "12", label: "Coochbehar Extension" },
        ]
        document.querySelectorAll(".myutil").forEach(input => input.disabled = true);
        setOptions(newOptions);
      }
      else if (currentlogin == "34" || currentlogin == "39" || currentlogin == "84") {
        const newOptions = [
          { value: "13", label: "Uttar Dinajpur Horticulture" },
          { value: "14", label: "Uttar Dinajpur Agronomy" },
          { value: "15", label: "Uttar Dinajpur Plant Protection" },
          { value: "16", label: "Uttar Dinajpur Animal Science" },
          { value: "17", label: "Uttar Dinajpur Home Science" },
          { value: "18", label: "Uttar Dinajpur Fishery Science" },
        ]
        document.querySelectorAll(".myutil").forEach(input => input.disabled = true);
        setOptions(newOptions);
      }
      else if(currentlogin == "35" || currentlogin == "40" || currentlogin == "85")
      {
        const newOptions = [
          { value: "19", label: "Dakshin Dinajpur Horticulture" },
          { value: "20", label: "Dakshin Dinajpur Soil Science" },
          { value: "21", label: "Dakshin Dinajpur Agronomy" },
          { value: "22", label: "Dakshin Dinajpur Animal Science" },
          { value: "23", label: "Dakshin Dinajpur Plant Protection" },
          { value: "24", label: "Dakshin Dinajpur Fishery Science" },
        ]
        setOptions(newOptions);
        document.querySelectorAll(".myutil").forEach(input => input.disabled = true);
      }
      else if(currentlogin == "36" || currentlogin == "41" || currentlogin == "86")
      {
        const newOptions = [
          { value: "25", label: "Malda Horticulture" },
          { value: "26", label: "Malda Agronomy" },
          { value: "27", label: "Malda Plant Protection" },
          { value: "28", label: "Malda Animal Science" },
          { value: "29", label: "Malda Extension" },
          { value: "30", label: "Malda Fishery Science" },
        ]
        setOptions(newOptions);
        document.querySelectorAll(".myutil").forEach(input => input.disabled = true);
      }

    }
    addOptions();
  }, [currentlogin])


  const defaultBudget = {
    ageneral: 0, ascsp: 0, anicra: 0, acfldo: 0, acfldp: 0, anf: 0, asponsored: 0, anabard: 0, aarya: 0, aosmv: 0, aseedhub: 0, aatma: 0, auniversity: 0,
    ugeneral: 0, uscsp: 0, unicra: 0, ucfldo: 0, ucfldp: 0, unf: 0, usponsored: 0, unabard: 0, uarya: 0, uosmv: 0, useedhub: 0, uatma: 0, uuniversity: 0,
    bgeneral: 0, bscsp: 0, bnicra: 0, bcfldo: 0, bcfldp: 0, bnf: 0, bsponsored: 0, bnabard: 0, barya: 0, bosmv: 0, bseedhub: 0, batma: 0, buniversity: 0,
  };

  useEffect(() => {
    const fetchBudgetData = async () => {
      if (!empid || !selectedYear) return;

      try {
        console.log(`Fetching for empid: ${empid}, year: ${selectedYear}`);
        const budgetRef = doc(db, "empmaster", empid, selectedYear, "budget");
        const docSnap = await getDoc(budgetRef);

        if (docSnap.exists()) {
          console.log("Fetched Data from Firestore:", docSnap.data());
          setBudgetData(docSnap.data());
        } else {
          console.log("No budget data found. Initializing defaults.");
          setBudgetData(defaultBudget);
        }
      } catch (error) {
        console.error("Error fetching budget data:", error);
      }
    };

    fetchBudgetData();
  }, [empid, selectedYear]);

  // Handle input change
  const handleInputChange = (e, key) => {
    setBudgetData((prev) => ({
      ...prev,
      [key]: Number(e.target.value),
    }));
  };

  // Update Firestore
  const updateBudgetData = async () => {
    if (!empid || !selectedYear) {
      alert("Please select an SMS and Financial Year first.");
      return;
    }

    try {
      console.log("Updating Firestore with:", budgetData);
      const budgetRef = doc(db, "empmaster", empid, selectedYear, "budget");
      await setDoc(budgetRef, budgetData, { merge: true });
      alert("Budget data updated successfully!");
    } catch (error) {
      console.error("Error updating budget data:", error);
      alert("Failed to update budget data.");
    }
  };

  const handleBack =(e)=>{
    e.preventDefault();
    navigate(-1)
  }

  return (
    <div className="container">
      {/* SMS Dropdown */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
        <h1 className="welcome">Fund Allocation for</h1>
        <select
          className="dropdown"
          value={empid}
          onChange={(e) => setEmpid(e.target.value)}
          style={{ width: "300px", height: "40px" }}
        >
          <option value="">Select SMS</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* Financial Year Selection */}
      <center>
        <select className="dropdown" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} style={{ width: "300px", height: "40px", marginTop: "10px" }}>
          <option value="">Select Financial Year</option>
          {["2024-25", "2025-26", "2026-27","2027-28"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </center>

      {/* Budget Table */}
      <table className="budget-table">
        <thead>
          <tr>
            <th style={{ width: "100px" }}>Budget</th>
            {["General", "SCSP", "NICRA", "CFLD(O)", "CFLD(P)", "Natural Farming", "Sponsored", "NABARD", "ARYA", "OSMV", "Seed Hub", "ATMA", "Others"].map((header) => (
              <th key={header} style={{ width: "60px" }}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Allocation</td>
            {Object.keys(defaultBudget).slice(0, 13).map((key) => (
              <td key={key}><input type="number" value={budgetData?.[key] || 0} onChange={(e) => handleInputChange(e, key)} style={{ width: "60px", textAlign: "center" }} /></td>
            ))}
          </tr>
          <tr>
            <td>Utilized</td>
            {Object.keys(defaultBudget).slice(13, 26).map((key) => (
              <td key={key}><input type="number" className="myutil" value={budgetData?.[key] || 0} onChange={(e) => handleInputChange(e, key)} style={{ width: "60px", textAlign: "center" }} /></td>
            ))}
          </tr>
          <tr>
            <td>Balance</td>
            {Object.keys(defaultBudget).slice(0, 13).map((key, index) => (
              <td key={key}>{(budgetData?.[key] || 0) - (budgetData?.[Object.keys(defaultBudget)[index + 13]] || 0)}</td>
            ))}
          </tr>
        </tbody>
      </table>

      {/* Update Button */}
      <center>
        <button id="updatebtn" onClick={updateBudgetData} style={{ marginTop: "20px", padding: "10px 20px", fontSize: "16px", backgroundColor: "green", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
          Update
        </button>
      </center>

      <br /><br /><br /><br />

      <center>
        <img src="/assets/back.png" style={{ width: '100px'}} onClick={handleBack} alt="" />
      </center>
    </div>
  );
};

export default FundAllocation;
